module.exports = __webpack_public_path__ + "static/media/severity4.99a3b551.png";